import { AuthUser } from '@app/account/account-api.model';
import { OpportunitiesPermissions } from '@app/account/models/permissions/opportunities-permissions.model';

export const opportunitiesMapper = (
  authUser: AuthUser
): OpportunitiesPermissions => ({
  isMentoringEnabled:
    (authUser.defaultOrgInfo?.organizationId ?? false) &&
    authUser.hasCareerMobility &&
    authUser.enableMentorshipOpportunities,

  hasCareerMobility: authUser.hasCareerMobility,
  hasMentorshipOpportunities: authUser.enableMentorshipOpportunities,
  viewOrganizationOpportunityInsights:
    authUser.defaultOrgInfo?.permissions?.viewOrganizationOpportunityInsights,
});
